import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';

const configuration = {
  type: 'entryCandle',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'entryCandle',
    name: 'entryCandle',
    config: {
      candleInterval: '5 minutes',
      valuePaths: [
        'item0.equity'
      ],
      resetOnDayStart: true,
      trailAnchor: false,
      when: [
        {
          leftOperand: '',
          operator: '',
          rightOperand: '',
          conditionOperator: 'and'
        }
      ],
    }
  },
  inputSchema: [
    {
      name: 'when',
      type: pipeInputSchemaTypes.signal,
      label: 'When',
    }, {
      name: 'resetOnDayStart',
      type: pipeInputSchemaTypes.select,
      label: 'Reset On Day Start',
      isDisplay: false,
      options: [
        { label: 'True', value: true },
        { label: 'False', value: false },
      ],
    },
    {
      name: 'trailAnchor',
      type: pipeInputSchemaTypes.select,
      label: 'Trail Anchor',
      options: [
        { label: 'True', value: true },
        { label: 'False', value: false },
      ],
    },
  ],
  searchTerms: [
    'Entry Candle'
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future]
  },
  buildOutputSchema: (pipe) => {
    const { name, type, config } = pipe;
    const { valuePaths = [] } = config;
    const [valuePath] = valuePaths;
    const isVolume = _.includes(valuePath, '.volume');
    let properties = [
      'close',
      'open',
      'high',
      'low',
      'openInterest',
      'volume'
    ];

    if (isVolume) {
      properties = [properties[0]]; // remove OHL
    }

    return _.map(properties, (property) => {
      return {
        name: `${name}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: `${name} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: true,
  priority: 1
};
export default configuration;
